export const SUPPLIER_LIST_REQUEST = "SUPPLIER_LIST_REQUEST";
export const SUPPLIER_LIST_SUCCESS = "SUPPLIER_LIST_SUCCESS";
export const SUPPLIER_LIST_FAIL = "SUPPLIER_LIST_FAIL";
export const SUPPLIER_LIST_RESET = "SUPPLIER_LIST_RESET";

export const SUPPLIER_SINGLE_REQUEST = "SUPPLIER_SINGLE_REQUEST";
export const SUPPLIER_SINGLE_SUCCESS = "SUPPLIER_SINGLE_SUCCESS";
export const SUPPLIER_SINGLE_FAIL = "SUPPLIER_SINGLE_FAIL";
export const SUPPLIER_SINGLE_RESET = "SUPPLIER_SINGLE_RESET";
